import { useEffect, useState, useCallback } from 'react'

import { withStyles } from '@material-ui/core/styles'
import dayjs from "dayjs"
import {
    Typography, Button,
    MenuItem, Select, InputLabel, FormControl, Grid, Box,
    Snackbar,
    SnackbarContent,
    Paper,Modal
} from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import { format } from 'date-fns'
import styles from './TicketStyles'
import axios from 'axios'
import CloseIcon from '@mui/icons-material/Close'
import Download from '@mui/icons-material/Download'
import { resolve } from 'url'
import { IconButton } from '@material-ui/core'
import EditIcon from '@mui/icons-material/Edit'
import DateFields from './DateFields'
import Fields from './Fields'
import exportFromJSON from 'export-from-json'
import { apiUrl, backendHosts } from '../../../../ui-utils/apiConfig'

const Ticket = ({ classes }) => {

    const [userData,setUserData]=useState(null)
    const [error, setError] = useState("")
    const [snack, setSnack] = useState(false)
    const [editModal, setEditModal] = useState(false)
    const [perData,setPerData]=useState(null)
    const [base64,setBase64]=useState(null)
    const [status,setStatus]=useState('Open')

    const [type,setType]=useState("")
    const [name, setName] = useState("")
    const [email, setEmail] = useState("")
    const [mobile,setMobile]=useState("")
    const [filterStatus, setFilterStatus] = useState("")
    const [tDate, setTdate] = useState(null)
    const [fDate, setFdate] = useState(null)

    const handleFdate = (value)=>{
        setFdate(dayjs(value).format('YYYY-MM-DD'))
        setType("")
        setName("")
        setEmail("")
        setFilterStatus("")
        setMobile("")
    }

    const handleTdate = (value) => {
        setTdate(dayjs(value).format('YYYY-MM-DD'))
        setType("")
        setName("")
        setEmail("")
        setFilterStatus("")
        setMobile("")
    }

    const handleName= (e) => {
        setName(e.target.value)
        setType("")
        setFilterStatus("")
        setTdate(null)
        setFdate(null)
    }

    const handleEmail = (e) => {
        setEmail(e.target.value)
        setType("")
        setFilterStatus("")
        setTdate(null)
        setFdate(null)
    
    }

    const handleMobile = (e) => {
        setMobile(e.target.value)
        setType("")
        setFilterStatus("")
        setTdate(null)
        setFdate(null)
    
    }

    const handleType = (e) => {
        setType(e.target.value)
        setName("")
        setEmail("")
        setFilterStatus("")
        setTdate(null)
        setFdate(null)
        setMobile("")
    }

    const handleStatus = (e) => {
        setFilterStatus(e.target.value)
        setType("")
        setName("")
        setEmail("")
        setTdate(null)
        setFdate(null)
        
        setMobile("")
    }

    



     useEffect(() => {
        fetchLearningCentreData()
      }, [])

      const fetchLearningCentreData = async (payload) => {
          try {
              const response = await axios.get(`${backendHosts.ADMIN}${apiUrl.getAllTickets}`)
              console.log("users", response.data.data?.data?.data)
            if (response.data.data.status === 200) {

              setUserData(response.data?.data?.data?.data)
            } else {
              console.log('Error in User List API', response.data)
            }
          } catch (error) {
            console.log('Error in User List API', error)
          }
        }

    const handleClose = () => {
        setEditModal(false)
        setStatus('Open')
        setPerData(null)
        setBase64(null)
          }
    const fontM = {
        fontFamily: "cardiuma-M !important"
    }

    const fontR = {
        fontFamily: "cardiuma-regular !important"
    }

    const handleEditModal = async(id) => {

        const data=userData.filter(ele => ele.id === id )
        // console.log("data",data) 
        setPerData(data[0])
      
        setEditModal(true)
        try {
            const response = await axios.get(`${backendHosts.ADMIN}${apiUrl.getATicket}${id}`)
            console.log("users", response.data.data?.data?.base64)
            if (response.data.data.status === 200) {

                setBase64(response.data.data?.data?.base64)
            } else {
                console.log('Error in Perticular user API', response.data)
            }
        } catch (error) {
            console.log('Error in Perticular user  API', error)
        }
    }

    const handleFieldSubmit=async ()=>{
        const payload = {
            data: {
                type,
                name,
                email,
                mobile,
                status:filterStatus || "",
                from:fDate || "",
                to:tDate || ""    
            }
        }
        console.log("payload", payload)
        try {
            const response = await axios.post(`${backendHosts.ADMIN}${apiUrl.ticketFilter}`, payload)

            if (response.data?.data?.status === 200) {
                setUserData(response.data.data?.data?.data)
            } else {
                console.log('Error in User List API', response.data)
            }
        } catch (error) {
            console.log('Error in Perticular user  API', error)
        }
    }


    const handleReset=()=>{
        
        setType("")
        setName("")
        setEmail("")
        setMobile("")
        setFilterStatus("")
        setTdate(null)
        setFdate(null)
        fetchLearningCentreData()
    }

    const handleDownloadCsv = () => {
        const header = [
            "Date",
            "Name",
            "Email",
            "Phone No",
            "Last Activity",
            "Type",
            "Status",
            "Description",
            "Closed By",
            "Closed At",
            "Closed Description"
        ];

        const data = userData.map(item => {
            return {
                [header[0]]: `${item.createdAt?.split("T")[0]} - ${item.createdAt?.split("T")[1]?.split(".")[0]}` || '-',
                [header[1]]: `${item.name || '-'}`,
                [header[2]]: `${item.email || '-'}`,
                [header[3]]: `${item.mobile || '-'}`,
                [header[4]]: `${item.updatedAt?.split("T")[0]} - ${item.updatedAt?.split("T")[1]?.split(".")[0]}` || '-',
                [header[5]]: `${item.type || '-'}`,
                [header[6]]: `${item.status || '-'}`,
                [header[7]]: `${item.description || '-'}`,
                [header[8]]: item.closed_by && item.closed_by.trim() !== "" ? item.closed_by : '-',
                [header[9]]: item.closed_at
                    ? `${item.closed_at.split("T")[0]} - ${item.closed_at.split("T")[1]?.split(".")[0]}`
                    : '-',
                [header[10]]: item.closed_description && item.closed_description.trim() !== ""
                    ? item.closed_description
                    : '-'
            };
        });

        const fileName = 'Tickets Case Report';
        const exportType = exportFromJSON.types.csv;

        exportFromJSON({ data, fileName, exportType });
    };
    
    

    const columns = [
        {
            field: 'actions',
            headerName: 'Action',
            align: 'center',
            headerAlign: 'center',
            flex: 1,
            renderCell: (params) => (
                <IconButton onClick={() => handleEditModal(params.id)} className={classes.edtIcnClr}>
                    <EditIcon  />
                </IconButton>
            ),
          },
        {
          field: 'createdAt',
          headerName: 'Date',
          align: 'center',
          headerAlign: 'center',
          flex: 1,
          valueFormatter: (params) => format(new Date(params), 'yyyy-MM-dd HH:mm')
        },
        {
          field: 'name',
          headerName: 'Name',
          align: 'center',
          headerAlign: 'center',
          flex: 1,
        },
        {
          field: 'email',
          headerName: 'Email',
          align: 'center',
          headerAlign: 'center',
          flex: 1,
        },
        {
          field: 'mobile',
          headerName: 'Phone no',
          type: 'number',
          align: 'center',
          headerAlign: 'center',
          flex: 1,
        },
        
        {
          field: 'type',
          headerName: 'Type',
          align: 'center',
          headerAlign: 'center',
          flex: 1,
        },
        
        {
          field: 'status',
          headerName: 'Status',
          align: 'center',
          headerAlign: 'center',
          flex: 1,
        },
        
      ]

    const downloadImage=()=>{
        let filename = perData?.mobile + "_" + `ticket.jpg`
        const link = document.createElement('a');
        link.href = base64
        link.download = filename
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);


    }

    const handleSaveStatusChange=async(id)=>{
        try {
            const response = await axios.patch(`${backendHosts.ADMIN}${apiUrl.updateTicket}${id}`,{
                data:{
                    status:status,
                    closed_by:"Admin",
                    closed_description:"This is to inform you that your request has for changing brokerage is recieved and completed"
                }
            })
            console.log("users", response.data.data?.data)
            if (response.data.data.status === 200) {
                

                setSnack(true)
                handleClose()
                fetchLearningCentreData()
            } else {
                console.log('Error in Edit API', response.data)
            }
        } catch (error) {
            console.log('Error in edit List API', error)
        }
    }

    const style = {
        position: 'absolute !important',
        top: '50% !important',
        left: '50% !important',
        transform: 'translate(-50%, -50%) !important',
        width: '60% !important',
      
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
        borderRadius: '15px !important',
       
      };
    return (
      
        <div className={classes.scrollTable}>
            <Typography
                className={classes.dashboardText2}
                style={{ color: '#FFFFFF', marginTop: '8%' }}
            >Tickets</Typography>
            <DateFields fDate={fDate} tDate={tDate} type={type}  handleTdate={handleTdate} handleFdate={handleFdate} handleType={handleType} />
            <Fields name={name} email={email} mobile={mobile} filterStatus={filterStatus} handleMobile={handleMobile} handleStatus={handleStatus} handleName={handleName} handleEmail={handleEmail} handleDownloadCsv={handleDownloadCsv} handleReset={handleReset} handleFieldSubmit={handleFieldSubmit} />
            <Paper className={classes.horizantalTablayout} sx={{ height: '80vh',marginTop:"40px"
             }}>
                     <DataGrid
                                    rows={userData}
                                    columns={columns}
                                    // filterModel={filterModel}
                                    // onFilterModelChange={handleNewFilter}
                                    className={classes.customDataGrid}
                                    sx={{
                                        '--DataGrid-containerBackground': '#131E2E',
                                        '--DataGrid-rowBorderColor': '#000',
                                        'border': 0,
                                        width:'100% !important', //dev-trupti on 23-10-2024
                    
                                    }}
                                    getRowId={(row) => row.id}
                                    initialState={{
                                        pagination: {
                                            paginationModel: { page: 0, pageSize: 15 },
                                        },
                                    }}
                    
                                    pageSizeOptions={[15, 25, 50]}
                                />
                  </Paper>

                  <Modal open={editModal} onClose={handleClose} aria-labelledby="modal-modal-title"
                          aria-describedby="modal-modal-description"
                         >
                  
                          <Box sx={style}>
                            <Box
                              sx={{
                            position: "relative", // Allows for absolute positioning of the close icon
                            width: "100%", // Ensures the box spans the entire width of the screen
                            display: "flex",
                            alignItems: "center",
                              }}
                            >
                              <Typography
                               
                                sx={{
                                  fontFamily: 'cardiuma-M',
                                  fontWeight: 'bold',
                                margin: "0 auto",
                                    fontSize:"20px !important"

                                }}
                              >
                              User Details
                              </Typography>
                  
                              <Button onClick={handleClose} sx={{ minWidth: 'unset', padding: '0' }}>
                                <CloseIcon style={{ color: 'red' }} />
                              </Button>
                            </Box>
                  
                            {/* Content section */}
                    <Grid
                        // container
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            // alignItems: "center", // Centers items vertically
                            paddingTop: "20px",
                            // height: "100vh", // Full viewport height
                        }}
                    >
                        <Grid
                            
                            lg={4}
                            sx={{
                                paddingLeft: "90px !important",
                            }}
                        >
                            <Typography mb={3} sx={fontM}>Name:</Typography>
                            <Typography mb={3} sx={fontM}>Email:</Typography>
                            <Typography mb={3} sx={fontM}>Phone no:</Typography>
                            <Typography mb={3} sx={fontM}>Type:</Typography>
                            {base64 ? <Typography mb={3} sx={fontM}>Download Image:</Typography> : null}
                           
                            {
                                perData?.status == 'closed' ?(<>
                                   
                                    <Typography mb={3} sx={fontM}>Closed Date:</Typography>
                                    <Typography mb={3} sx={fontM}>Closed By:</Typography>
                                    <Typography mb={11} sx={fontM}>Closed Description:</Typography>
                                   
                                </>):(<>
                                  
                                    <Typography mb={3} sx={fontM}>Change Status:</Typography>
                                    <Typography mb={11} sx={fontM}>Description:</Typography>
                                </>)
                            }
                        </Grid>
                        <Grid  lg={4}>
                            <Typography sx={fontR} mb={3}>{perData?.name}</Typography>
                            <Typography sx={fontR} mb={3}>{perData?.email}</Typography>
                            <Typography sx={fontR} mb={3}>{perData?.mobile}</Typography>
                            <Typography sx={fontR} mb={3}>{perData?.type}</Typography>
                            
                            {
                                base64 ? <> <Typography mb={2} sx={fontM}>
                                    <Download
                                        sx={{ color: "#00acfe", cursor: "pointer" }}
                                        onClick={downloadImage}
                                    />
                                </Typography></> : null
                            }

                            {
                                perData?.status == 'closed' ? (
                                <>
                                        <Typography sx={fontR} mb={3}>
                                            {dayjs(perData?.closed_at).format('YYYY-MM-DD HH:mm')}
                                                    </Typography>
                                        <Typography sx={fontR} mb={3}>{perData?.closed_by}</Typography>
                                        <Typography sx={fontR} mb={3}>{perData?.closed_description}</Typography>
                                </>) : (<>
                                    
                                    <Typography sx={fontR} mb={3}>
                                        <Grid style={{ marginLeft: "0px", borderRadius: "5px" }}>
                                            <FormControl size="small" style={{ width: "50%" }}>
                                                <InputLabel
                                                    className={classes.inputColor}
                                                    id="demo-select-small-label"
                                                    shrink={true} // Ensure the label shrinks
                                                >
                                                    Status
                                                </InputLabel>
                                                <Select
                                                    className={classes.select}
                                                    labelId="demo-select-small-label"
                                                    id="demo-select-small"
                                                    value={status} // Initial value "Open" set here
                                                    label="Status"
                                                    onChange={(e) => {
                                                        const updatedStage = e.target.value;
                                                        console.log("Selected Stage:", updatedStage);
                                                        setStatus(updatedStage);
                                                    }}
                                                    displayEmpty
                                                    MenuProps={{
                                                        PaperProps: {
                                                            style: {
                                                                top: "50px", // Control where dropdown will appear
                                                            },
                                                        },
                                                    }}
                                                >
                                                    <MenuItem className={classes.intSelText} value="Open">
                                                        Open
                                                    </MenuItem>
                                                    <MenuItem className={classes.intSelText} value="closed">
                                                        Close
                                                    </MenuItem>
                                                </Select>
                                            </FormControl>


                                        </Grid>

                                        {/* {error && <Typography color="error" mt={1}>{error}</Typography>} */}
                                    </Typography>
                                   <Typography sx={fontR} mb={4}>{perData?.description}</Typography>
                                </>)
                            }
                           
                        </Grid>
                    </Grid>
                    {
                        perData?.status == 'closed'? <>
                        
                        </> :<>
                        
                                <Grid
                                    sx={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        paddingRight: "50px",
                                        paddingBottom: "10px",
                                    }}
                                >
                                    <Button
                                        onClick={() => handleSaveStatusChange(perData.id)}
                                        sx={{
                                            fontFamily: "cardiuma-regular",
                                            color: "#ffffff",
                                            background: "#F44748",
                                            width: "80px",
                                            height: "35px",
                                            "&:hover": {
                                                background: "#F44748", // Keep the same color on hover
                                            },
                                            "&.Mui-disabled": {
                                                background: "#D3D3D3", // Custom color for disabled state
                                                color: "#ffffff", // Keep the text color
                                            },
                                        }}
                                        disabled={status !== "closed"}
                                    >
                                        Save
                                    </Button>
                                </Grid></>
                    }
                   

                          </Box>
                        </Modal>



            <Snackbar
                open={snack}
                autoHideDuration={2000}
                onClose={() => setSnack(false)}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            >
                <SnackbarContent
                    sx={{
                        backgroundColor: "#ffffff !important",
                        color: "black !important",
                        borderLeft: "7px solid #8db600 !important",
                        borderRadius: "3px !important",
                        fontFamily: "cardiuma-regular !important",
                        fontSize: "12px !important",
                    }}
                    message={"updated successfully"}
                />
            </Snackbar>

        </div>
    )
}

export default withStyles(styles)(Ticket)